import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { ACCESS_SERVICE_PROVIDER } from 'src/app/global/services/access-control/access-control.service';
import { SearchDropdownComponent } from './search-dropdown.component';

@NgModule({
    declarations: [SearchDropdownComponent],
    imports: [CommonModule, ReactiveFormsModule, MatAutocompleteModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressSpinnerModule, TranslateModule],
    providers: [ACCESS_SERVICE_PROVIDER],
    exports: [SearchDropdownComponent],
})
export class SearchDropdownModule {}
